import React from "react";
import styled from "styled-components";
import ToolIconCard from "./sub-components/ToolIconCard";
import { SectionHeadline } from "./Typography";
import { typography } from "../styles/designSystem";

// Logos
import figma from "../pngs/Figma.png";
import react from "../pngs/React_(web_framework)-Logo.wine.png";
import nextjs from "../pngs/Nextjs.svg";
import nodejs from "../pngs/Node.js.png";
import jira from "../pngs/Jira_logo_PNG4.png";
import ClaudeLogo from "../pngs/Claude.png";
import SwaggerLogo from "../pngs/swagger-logo.png";
import FirebaseLogo from "../pngs/FirebaseLogo.svg";
import SupabaseLogo from "../pngs/SupabaseLogo.svg";

const Section = styled.section`
    padding: 5rem 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
    text-align: center;
`;

const Heading = styled(SectionHeadline)`
    margin-bottom: 3rem;
`;

const StackContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        gap: 1.5rem;
    }
`;

const StackGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    background: ${({ theme }) => theme.cardBackground};
    border: 1px solid ${({ theme }) => theme.borderLight};
    box-shadow: inset 0 0 40px rgba(0, 0, 0, 0.5);
    padding: 2rem 2.5rem;
    flex: 1;
    min-width: 200px;
    max-width: 380px;

    @media (max-width: 768px) {
        width: 100%;
        max-width: 400px;
        padding: 1.5rem 2rem;
    }
`;

const StackLabel = styled.span`
    font-family: ${typography.fontFamily.display};
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: ${typography.letterSpacing.widest};
    color: ${({ theme }) => theme.primary};
    padding-bottom: 0.75rem;
    border-bottom: 1px solid ${({ theme }) => theme.borderLight};
    width: 100%;
    text-align: center;
`;

const StackItems = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
`;

const ToolsSection = () => {
    return (
        <Section>
            <Heading>Equipped Stack</Heading>
            <StackContainer>
                <StackGroup>
                    <StackLabel>Frontend</StackLabel>
                    <StackItems>
                        <ToolIconCard src={react} alt="React" label="React" />
                        <ToolIconCard src={nextjs} alt="Next.js" label="Next.js" />
                    </StackItems>
                </StackGroup>
                <StackGroup>
                    <StackLabel>Backend &amp; Data</StackLabel>
                    <StackItems>
                        <ToolIconCard src={nodejs} alt="Node.js" label="Node.js" />
                        <ToolIconCard src={SwaggerLogo} alt="Swagger" label="Swagger" />
                        <ToolIconCard src={FirebaseLogo} alt="Firebase" label="Firebase" />
                        <ToolIconCard src={SupabaseLogo} alt="Supabase" label="Supabase" />
                    </StackItems>
                </StackGroup>
                <StackGroup>
                    <StackLabel>Design &amp; Workflow</StackLabel>
                    <StackItems>
                        <ToolIconCard src={figma} alt="Figma" label="Figma" />
                        <ToolIconCard src={jira} alt="Jira" label="Jira" />
                        <ToolIconCard src={ClaudeLogo} alt="Claude" label="Claude" />
                    </StackItems>
                </StackGroup>
            </StackContainer>
        </Section>
    );
};

export default ToolsSection;
